import {
    createTable,
    ITableRow,
    ITableProperties,
    Table,
} from '@vfde-brix/ws10/table';
import { ADDITIONAL_PAGE_OPTIONS } from '@vfde-sails/constants';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { AbstractedAttribute } from '@vfde-sails/glados-v2';

/**
 * Mount the simple table
 */
export const mountTable = (container: HTMLElement, data: AbstractedAttribute[]): Table => {
    const listRow = [];
    const valueSpecials: Record<string, CallableFunction> = {
        Nachhaltigkeit: getEcoLabel, // eslint-disable-line @typescript-eslint/naming-convention
    };

    for (const attribute of data) {
        const valueSpecial = valueSpecials[attribute.label.replace(' ', '-')];
        const item: ITableRow = valueSpecial ? valueSpecial(attribute.label, attribute.value) : {
            stdLabel: attribute.label,
            stdText: attribute.value,
        };

        listRow.push(item);
    }

    const properties: ITableProperties = {
        listRow,
        business: NO_PATTERN_BUSINESS_LOGIC,
    };

    return createTable(container, properties);
};

const getEcoLabel = (label: string, value: string): ITableRow => {
    const { link, text } = window[ADDITIONAL_PAGE_OPTIONS].ecoLabel;

    // TODO: change to WS10

    return {
        stdLabel: label,
        stdText: `${value} <a href=${link} class="ws10-text-link" target="_blank" rel="noopener noreferrer">${text}</a>`,
    };
};
